import { useState } from "react";
import { Link } from "react-router-dom";

/**
 * Sub-navigation item component for dropdown menus.
 * Uses React Router Link for client-side navigation to preserve cache.
 * @param {Object} props - Component props
 * @param {string} props.color - Text color
 * @param {string} props.hoverColor - Hover text color
 * @param {string} props.url - Navigation URL
 * @param {string} props.text - Display text
 * @param {boolean} props.isMobile - Whether in mobile view
 */
function SubNavItem({ color, hoverColor, url, text, isMobile }) {
  const [hovered, setHovered] = useState(false);
  function handleHover(state) {
    if (!isMobile) {
      setHovered(state);
    }
  }

  return (
    <Link
      style={{
        color: hovered ? hoverColor : color,
      }}
      className="sub-nav-item"
      to={url}
      onMouseEnter={() => {
        handleHover(true);
      }}
      onMouseLeave={() => {
        handleHover(false);
      }}
    >
      {text}
    </Link>
  );
}

export default SubNavItem;
